import { useMutation } from "./urqlHooks";

const SET_PASSWORD_INCLUDE_IN_CASH_FLOW = `
mutation SetPasswordIncludeInCashFlow($passwordId: String!, $companyId: String!, $includeInCashFlow: Boolean!) {
  setPasswordIncludeInCashFlow(passwordId: $passwordId, companyId: $companyId, includeInCashFlow: $includeInCashFlow) {
    id
    includeInCashFlow
  }
}
`;

export const SetPasswordIncludeInCashFlow = () => {
  const [result, executeMutation] = useMutation(SET_PASSWORD_INCLUDE_IN_CASH_FLOW);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};

const SET_INITIAL_BALANCE_INCLUDE_IN_CASH_FLOW = `
mutation SetInitialBalanceIncludeInCashFlow($id: String!, $companyId: String!, $includeInCashFlow: Boolean!) {
  setInitialBalanceIncludeInCashFlow(id: $id, companyId: $companyId, includeInCashFlow: $includeInCashFlow) {
    id
    meta {
      ... on InitialBalanceMeta {
        includeInCashFlow
      }
    }
  }
}
`;

export const SetInitialBalanceIncludeInCashFlow = () => {
  const [result, executeMutation] = useMutation(SET_INITIAL_BALANCE_INCLUDE_IN_CASH_FLOW);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};
